// Add Animation
document.addEventListener("DOMContentLoaded", function() {
  const items = document.querySelectorAll(".about-animate-section .animate-item");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {

        // stagger effect
        setTimeout(() => {
          entry.target.classList.add("visible");
        }, index * 150);

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  items.forEach(item => {
    observer.observe(item);
  });

});

// LightBox Popup On Product Detail Page (Only for screens >= 768px)

document.addEventListener("DOMContentLoaded", function () {

  // Stop script on mobile screens
  if (window.innerWidth < 991) {
    return;
  }

  const mediaItems = document.querySelectorAll(".gsp-product-thumb");

  mediaItems.forEach(item => {

    const img = item.querySelector("img");

    // VIDEO
    if (item.classList.contains("gsp-product-thumb-video")) {

      const template = item.querySelector("template");

      if (template) {

        const videoEl = template.content.querySelector("video source");
        const videoTag = template.content.querySelector("video");

        if (videoEl && videoTag && img) {

          const videoSrc = videoEl.src;
          const poster = videoTag.poster || img.src;

          img.setAttribute("data-fancybox", "product-gallery");
          img.setAttribute("data-type", "html5video");
          img.setAttribute("href", videoSrc);
          img.setAttribute("data-thumb", poster);
          img.setAttribute("data-caption", "Product Video");

        }

      }

    }

    // IMAGE
    else if (img) {

      const srcset = img.getAttribute("srcset");
      let realSrc = img.src;

      if (srcset) {
        const parts = srcset.split(",");
        realSrc = parts[parts.length - 1].split(" ")[0];
      }

      img.setAttribute("data-fancybox", "product-gallery");
      img.setAttribute("href", realSrc);
      img.setAttribute("data-caption", img.alt || "Product Image");

    }

  });

  Fancybox.bind("[data-fancybox='product-gallery']", {

    Toolbar: {
      display: ["close","counter","prev","next","download"]
    },

    Thumbs: true,

    Html5Video: {
      autoplay: false
    },

    Carousel: {

      infinite: false,

      on: {

        ready: () => {
          stopAllVideos();
        },

        change: () => {
          stopAllVideos();
        }

      }

    }

  });

  function stopAllVideos() {

    const videos = document.querySelectorAll(".fancybox__slide video");

    videos.forEach(video => {

      video.pause();
      video.currentTime = 0;
      video.removeAttribute("autoplay");

    });

  }

});

// Product Detail Page Responsive Slider
$(document).ready(function () {
  function productMediaSlider() {
    if ($(window).width() <= 991) {
      if (!$(".product-featured .row, .gsp-section-featured-collection").hasClass("slick-initialized")) {
        $(".product-featured .row").slick({
          slidesToShow: 1.1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          infinite: false,
          adaptiveHeight: true,

          prevArrow:
            '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',

          nextArrow:
            '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
        });
      }
    } else {
      if ($(".product-featured .row").hasClass("slick-initialized")) {
        $(".product-featured .row").slick("unslick");
      }
    }
  }

  productMediaSlider();

  $(window).resize(function () {
    productMediaSlider();
  });
});

// Home Page Meet Our Latest Launch
document.addEventListener("click", function (e) {

  const section = e.target.closest(".latest-launch-block");
  if (!section) return;

  const button = section.querySelector(".gsp-heading-button a");
  if (!button) return;

  const url = button.getAttribute("href");

  const image = e.target.closest(".latest-launch-img img");
  const title = e.target.closest(".gsp-heading-title");

  if (image || title) {
    window.location.href = url;
  }

});